import { type Comparator, type LogicalOperator } from '~/constants/operators';

import type SavedAPIAddress from './APIAddress';
import type ParcelTemplate from './ParcelTemplate';

import { type JSONAPIAddress } from './APIAddress';
import { type OrderTag } from './Order';
import { type JSONParcelTemplate } from './ParcelTemplate';

type JSONBusinessRule = {
  account_object_id?: string;
  description?: string;
  filter_group?: JSONFilterGroup;
  name?: string;
  object_id: string;
  object_updated: string;
  rank_desc: number;
  rule_type: string;
  sender_address?: JSONAPIAddress;
  service_level_token: string;
  tag_id?: string;
  user_parcel_template: JSONParcelTemplate;
};

type BusinessRule = {
  accountObjectId?: string;
  description?: string;
  filterGroup?: FilterGroup;
  name?: string;
  objectId: string;
  objectUpdated: Date;
  rankDesc: number;
  ruleType: string;
  senderAPIAddress?: SavedAPIAddress;
  serviceLevelToken?: string;
  tag?: OrderTag;
  tagId?: string;
  userParcelTemplate?: ParcelTemplate;
};

type JSONFilterGroup = {
  filter_entity: string;
  filters: JSONFilterOrClause[];
  id: number;
  object_id: string;
};

type FilterGroup = {
  filterEntity: string;
  filters: FilterOrClause[];
  id: number;
  objectId: string;
};

type JSONFilterOrClause = JSONFilter | JSONFilterClause;
type FilterOrClause = Filter | FilterClause;

// distinguish whether a (JSON)FilterOrClause represents a Filter or FilterClause
const isFilter = (filterOrClause: FilterOrClause | JSONFilterOrClause): boolean =>
  !filterOrClause.hasOwnProperty('operator');

type JSONFilterClause = {
  filters: JSONFilterOrClause[];
  operator: LogicalOperator;
};

type FilterClause = {
  filters: FilterOrClause[];
  operator: LogicalOperator;
};

type JSONFilter = {
  comparator: Comparator;
  field: string;
  filter_values: FilterValue[];
  id: number;
};

type Filter = {
  comparator: Comparator;
  comparatorString: string; // 'less than'
  field: string;
  filterValues: FilterValue[];
  id: number;
  symbolString: string; // '< 5 lb'
  value: string; // '5 lb'
  wordString: string; // 'less than 5 lb'
};

// Used in JSONFilter because the values are unchanged
type FilterValue = {
  boolean: boolean;
  date: string;
  enum: string;
  text: string;
  value: string;
};

type ReorderRulePayload = {
  object_id: string;
  rank: number;
};

export default BusinessRule;

export {
  Filter,
  FilterClause,
  FilterGroup,
  FilterOrClause,
  FilterValue,
  JSONBusinessRule,
  JSONFilter,
  JSONFilterClause,
  JSONFilterGroup,
  JSONFilterOrClause,
  ReorderRulePayload,
  isFilter,
};
